export default __webpack_public_path__ + "static/media/Illustration_Resume.78d55581.svg";